import React from 'react';

import {
    FormGroup,
    Col,
} from 'react-bootstrap';
import TimePicker from 'react-bootstrap-time-picker';
import dateHelper from '../../helpers/date.js';

module.exports = class HoursRow extends React.Component {
    constructor() {
        super();
        this.state = {
            StartTime: '08:00',
            EndTime: '17:00',
            isChecked: false,
            error: ""
        };

        this.changeValue = this.changeValue.bind(this);
    }

    handleStartTimeChange(time) {
        this.setState({ StartTime: time });
    }

    handleEndTimeChange(time) {
        this.setState({ EndTime: time });
    }

    dateEnabledChange() {
        if (this.state.isChecked) {
            this.setState({ isChecked: false })
        }
        else {
            this.setState({ isChecked: true })
        }
    }

    changeValue(start, end) {
        if (this._checkbox)
            this._checkbox.click();
        this.setState({
            isChecked: true,
            StartTime: start,
            EndTime: end
        });
    }

    validate() {
        if (this.state.isChecked && this.state.StartTime >= this.state.EndTime) {
            this.setState({
                error: "Start time must be before end time"
            });
            return false;
        }
        else {
            this.setState({
                error: ""
            });
            return true;
        }
    }

    render() {
        var className = this.state.isChecked ? "" : "disabled";
        var disabled = this.state.isChecked ? false : true;
        var startID = this.props.id + "Start";
        var endID = this.props.id + "End";
        var dayInput;
        if (this.props.status == 'edit' || this.props.status == 'new') {
            dayInput = <span><div className='toggle'>
                <input
                    type='checkbox'
                    id={this.props.id}
                    name={this.props.id}
                    className='cmn-toggle cmn-toggle-round'
                    onClick={this.dateEnabledChange.bind(this)} ref={(checkbox) => {
                        this._checkbox = checkbox;
                    }} />
                <label htmlFor={this.props.id}></label>
            </div>
                <label>{this.props.day}</label>
            </span>
        }
        else {
            dayInput = <label>{this.props.day}</label>
        }
        var timeInput;
        if (this.props.status == 'edit' || this.props.status == 'new') {
            var errorClass = "hidden";
            if (this.state.error != "") {
                errorClass = "error";
            }
            timeInput = <span>
                <TimePicker id={startID} name={startID} disabled={disabled} className='timePicker' start="00:00" end="23:59" onChange={this.handleStartTimeChange.bind(this)} value={this.state.StartTime} format={24} step={15} />
                <label> - </label>
                <TimePicker id={endID} name={endID} disabled={disabled} className='timePicker' start="00:00" end="23:59" onChange={this.handleEndTimeChange.bind(this)} value={this.state.EndTime} format={24} step={15} />
                <label className={errorClass}>{this.state.error}</label>
            </span>
        }
        else {
            if (this.state.isChecked) {
                timeInput = <label>{dateHelper.fromSecondsToTime(this.state.StartTime)} - {dateHelper.fromSecondsToTime(this.state.EndTime)}</label>
            }
            else {
                timeInput = <label>Day off</label>;
            }
        }
        return (
            <FormGroup className={className}>
                <Col lg={6} className='checkbox-label'>
                    {dayInput}
                </Col>
                <Col lg={6}>
                    {timeInput}
                </Col>
            </FormGroup>
        )
    }
}


// WEBPACK FOOTER //
// ./modules/register/HoursRow.jsx